import { QuesState } from 'shared/types/QuesTypes';
import { ReduxAction } from 'shared/types/ReduxAction';
import { ReduxReducer } from 'shared/types/ReduxReducer';
import { SurveySection } from 'shared/types/SurveyResponses';

export const GET_ALL_TRANSLATED_LANGUAGES = 'GET_ALL_TRANSLATED_LANGUAGES';
export const GET_GOOGLE_LANGUAGES_LIST = 'GET_GOOGLE_LANGUAGES_LIST';
export const SET_ALL_TRANSLATED_LANGUAGES = 'SET_ALL_TRANSLATED_LANGUAGES';
export const SET_GOOGLE_LANGUAGES_LIST = 'SET_GOOGLE_LANGUAGES_LIST';
export const ADD_TRANSLATION_LANGUAGE = 'ADD_TRANSLATION_LANGUAGE';
export const SAVE_TRANSLATION_LANGUAGE = 'SAVE_TRANSLATION_LANGUAGE';
export const DELETE_TRANSLATION_LANGUAGE = 'DELETE_TRANSLATION_LANGUAGE';
export const GET_TRANSLATED_DATA = 'GET_TRANSLATED_DATA';
export const SET_TRANSLATED_DATA = 'SET_TRANSLATED_DATA';
export const CHANGE_QUESTION_TRANSLATE_INFO = 'CHANGE_QUESTION_TRANSLATE_INFO';
export const SET_TRANSLATED_QUESTION_INFO = 'SET_TRANSLATED_QUESTION_INFO';
export const CHANGE_OPTION_TRANSLATE_INFO = 'CHANGE_OPTION_TRANSLATE_INFO';
export const CHANGE_SECTION_TRANSLATE_INFO = 'CHANGE_SECTION_TRANSLATE_INFO';
export const CHANGE_QUESTION_SETTING_TRANSLATE_INFO = 'CHANGE_QUESTION_SETTING_TRANSLATE_INFO';
export const CHANGE_MULTIPLE_OPINION_SECTION_TRANSLATE_INFO = 'CHANGE_MULTIPLE_OPINION_SECTION_TRANSLATE_INFO';
export const CHANGE_MULTIPLE_OPINION_STROKE_TRANSLATE_INFO = 'CHANGE_MULTIPLE_OPINION_STROKE_TRANSLATE_INFO';
export const UPLOAD_MULTI_LINGUAL_CSV = 'UPLOAD_MULTI_LINGUAL_CSV';
export const GET_DEFAULT_BUTTONS_DATA = 'GET_DEFAULT_BUTTONS_DATA';
export const SET_DEFAULT_BUTTONS_DATA = 'SET_DEFAULT_BUTTONS_DATA';
export const GET_TRANSLATED_BUTTONS_DATA = 'GET_TRANSLATED_BUTTONS_DATA';
export const POST_TRANSLATE_BUTTONS_DATA = 'POST_TRANSLATE_BUTTONS_DATA';
export const SET_TRANSLATED_BUTTON_DATA = 'SET_TRANSLATED_BUTTON_DATA';
export const CHANGE_BUTTONS_TRANSLATE_INFO = 'CHANGE_BUTTONS_TRANSLATE_INFO';
export const SET_TRANSLATED_BUTTONS_INFO = 'SET_TRANSLATED_BUTTONS_INFO';
export const UPDATE_LANGUGAE_STATUS = 'UPDATE_LANGUGAE_STATUS';

export type GoogleLanguagesDataList = {
	id: string;
	createdAt: string;
	updatedAt: string;
	code: string;
	name: string;
};

export type DefaultButtonsDataListType = {
	id: string;
	createdAt: string;
	updatedAt: string;
	defaultText: string;
};

export type TranslatedButtonsDataListType = {
	id: string;
	textId: string;
	ui_text: string;
	surveyId: string;
	languageCode: string;
	translatedText: string;
	createdAt: string;
	updatedAt: string;
};

export type SurveyMultiLingualDataState = {
	googleLanguagesList: GoogleLanguagesDataList[];
	savedSurveyLanguages: GoogleLanguagesDataList[];
	currentEditingLanguageCode: string;
	currentEditingLanguageQues: any[];
	defaultButtonsList: DefaultButtonsDataListType[];
	currentEditingLanguageButtonsData: TranslatedButtonsDataListType[];
};

export type GetAllTranslatedLanguagesAction = ReduxAction<typeof GET_ALL_TRANSLATED_LANGUAGES, { surveyId: string }>;

export type GetGoogleLanguagesListAction = ReduxAction<typeof GET_GOOGLE_LANGUAGES_LIST, undefined>;

export type SetGoogleLanguagesListAction = ReduxAction<
	typeof SET_GOOGLE_LANGUAGES_LIST,
	{
		data: GoogleLanguagesDataList[];
	}
>;

export type SetAllTranslatedLanguagesAction = ReduxAction<
	typeof SET_ALL_TRANSLATED_LANGUAGES,
	{
		data: GoogleLanguagesDataList[];
	}
>;

export type AddTranslationLanguageAction = ReduxAction<
	typeof ADD_TRANSLATION_LANGUAGE,
	{
		languages: GoogleLanguagesDataList[];
		surveyId: string;
		autoTranslate: boolean;
	}
>;

export type SaveTranslationLanguageAction = ReduxAction<
	typeof SAVE_TRANSLATION_LANGUAGE,
	{
		languages: GoogleLanguagesDataList[];
	}
>;

export type DeleteTranslationLanguageAction = ReduxAction<
	typeof DELETE_TRANSLATION_LANGUAGE,
	{ surveyId: string; langCode: string }
>;

export type GetTranslatedDataAction = ReduxAction<typeof GET_TRANSLATED_DATA, { surveyId: string; langCode: string }>;

export type SetTranslatedDataAction = ReduxAction<typeof SET_TRANSLATED_DATA, { data: any }>;

export type ChangeQuestionTranslateInfo = ReduxAction<
	typeof CHANGE_QUESTION_TRANSLATE_INFO,
	{ questionId: string; languageCode: string; surveyId: string; content }
>;

export type ChangeOptionTranslateInfo = ReduxAction<
	typeof CHANGE_OPTION_TRANSLATE_INFO,
	{ questionId: string; languageCode: string; optionId: string; value: string }
>;

export type ChangeSectionTranslateInfo = ReduxAction<
	typeof CHANGE_SECTION_TRANSLATE_INFO,
	{ id: string; languageCode: string; surveyId: string; metaData }
>;

export type ChangeQuestionSettingTranslateInfo = ReduxAction<
	typeof CHANGE_QUESTION_SETTING_TRANSLATE_INFO,
	{ questionId: string; languageCode: string; surveyId: string; settings; isSection: boolean }
>;

export type ChangeMultipleOpinionSectionTranslateInfo = ReduxAction<
	typeof CHANGE_MULTIPLE_OPINION_SECTION_TRANSLATE_INFO,
	{ sectionId: string; questionId: string; languageCode: string; content }
>;

export type ChangeMultipleOpinionStrokeTranslateInfo = ReduxAction<
	typeof CHANGE_MULTIPLE_OPINION_STROKE_TRANSLATE_INFO,
	{ sectionId: string; questionId: string; languageCode: string; strokeId: string; text: string; content }
>;

export type SetTranslatedQuestionInfo = ReduxAction<
	typeof SET_TRANSLATED_QUESTION_INFO,
	{ questionId: string; state: QuesState | SurveySection }
>;

export type UploadMultiLingualCsv = ReduxAction<
	typeof UPLOAD_MULTI_LINGUAL_CSV,
	{ file: File; languageCode: string; questionnaireId: string }
>;

export type GetDefaultButtonsDataAction = ReduxAction<typeof GET_DEFAULT_BUTTONS_DATA, undefined>;

export type SetDefaultButtonsDataAction = ReduxAction<
	typeof SET_DEFAULT_BUTTONS_DATA,
	{
		data: DefaultButtonsDataListType[];
	}
>;

export type GetTranslatedButtonsDataAction = ReduxAction<
	typeof GET_TRANSLATED_BUTTONS_DATA,
	{ surveyId: string; langCode: string }
>;

export type PostTranslateButtonsData = ReduxAction<typeof POST_TRANSLATE_BUTTONS_DATA, { surveyId: string }>;

export type SetTranslatedButtonDataAction = ReduxAction<typeof SET_TRANSLATED_BUTTON_DATA, { data: any }>;

export type ChangeButtonsTranslateInfo = ReduxAction<
	typeof CHANGE_BUTTONS_TRANSLATE_INFO,
	{ language: string; surveyId: string; uiText: string; textId: string; translated_text: string }
>;

export type SetTranslatedButtonsInfo = ReduxAction<typeof SET_TRANSLATED_BUTTONS_INFO, { text: string; id: string }>;

export type UpdateLangugaeStatus = ReduxAction<
	typeof UPDATE_LANGUGAE_STATUS,
	{ id: string; langugaeCode: string; status: string }
>;

export type SurveyMultiLingualDataReducer = ReduxReducer<
	SurveyMultiLingualDataState,
	| GetGoogleLanguagesListAction
	| SetGoogleLanguagesListAction
	| AddTranslationLanguageAction
	| SaveTranslationLanguageAction
	| DeleteTranslationLanguageAction
	| GetTranslatedDataAction
	| SetTranslatedDataAction
	| ChangeQuestionTranslateInfo
	| ChangeOptionTranslateInfo
	| SetTranslatedQuestionInfo
	| ChangeSectionTranslateInfo
	| ChangeQuestionSettingTranslateInfo
	| ChangeMultipleOpinionSectionTranslateInfo
	| ChangeMultipleOpinionStrokeTranslateInfo
	| GetAllTranslatedLanguagesAction
	| SetAllTranslatedLanguagesAction
	| UploadMultiLingualCsv
	| GetDefaultButtonsDataAction
	| SetDefaultButtonsDataAction
	| GetTranslatedButtonsDataAction
	| SetTranslatedButtonDataAction
	| ChangeButtonsTranslateInfo
	| SetTranslatedButtonsInfo
	| UpdateLangugaeStatus
>;
